module.exports = __webpack_public_path__ + "c9962a31e8cf6de30e769de3989ed21b.svg";